import { Component, ElementRef, ViewEncapsulation, NgZone, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { TranslateService, TranslatePipe, TranslateModule } from '@ngx-translate/core';
import { CommonService } from './shared/services/common.service';
import 'hammerjs';
import { interval, Subscription } from 'rxjs';
import * as myGlobals from './shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CSharpRequestService } from './shared/services/csharp-request.service';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { AuthenticationService } from './core/services/authentication.service';
import { PopupComponent } from './shared/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { apiURLs, Default_SessionInactivityTime, userSessionName } from './shared/globalcontants';
import { EatecTokenRefreshService } from './core/services/eatec-token-refresh.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import * as appApiResources from './shared/globalcontants';
import { IdlePopupComponent } from './shared/Idlepopup/idlepopup.component';
import { MsalService, MsalModule } from '@azure/msal-angular';
import { TentantInfo } from './auth-config.interface';
import { ConfigService } from './config.service';
import moment from 'moment-timezone';
import { MatButton } from '@angular/material/button';
import { MatSpinner } from '@angular/material/progress-spinner';
import { ToastMessageComponent } from './shared/toast-message/toast-message.component';
// import { ConfigurationService } from 'receiving';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterOutlet, MatButton, MatSpinner, TranslateModule, MsalModule, ToastMessageComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  tokenKey = 'a5smm_utoken';
  show = false;
  message = '';
  toastShow = false;
  toastMessage: string;
  offlineText: string;
  onlineText: string;
  showOnlineAlert = true;
  deviceInfo: any;
  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;
  timedOut = false;
  idleTimeoutSubscribtion: Subscription;
  dialogRef: any;
  isIframe = false;
  loginDisplay = false;
  passcodePopupShow: Subscription;
  tempPasscodePopupShow: Subscription;
  createMesasgeSubscription: Subscription;
  PasscodeExpiredsubscribe: Subscription;
  /** Tracks URL across navigations so we can re-apply ng-idle after leaving `/login` (InactivityTimeout may emit before router updates). */
  private routerUrlSnapshotForIdleSync = '';
  constructor(
    private dialog: MatDialog, private _ngZone: NgZone,
    public authService: AuthenticationService,
    public router: Router,
    public translate: TranslateService,
    public er: ElementRef,
    private deviceService: DeviceDetectorService,
    public cs: CommonService,
    public csharpService: CSharpRequestService,
    private authentication: AuthenticationService,
    private idle: Idle,
    private keepalive: Keepalive,
    private cd: ChangeDetectorRef,
    private msalService: MsalService,
    private azureConfig: ConfigService,
    private eatecTokenRefreshService: EatecTokenRefreshService
    ) {
    const tenant = this.azureConfig.getSettings().TenantIdentifier;
    localStorage.setItem('tenant', tenant);
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.cs.deviceType = this.deviceInfo.device;
    const deviceOS = ['ios', 'ipados', 'mac'].includes(this.deviceInfo.os?.toLowerCase()) ? 'iOS' : this.deviceInfo.os;
    window.localStorage.setItem('deviceType', deviceOS);
    translate.addLangs(['en', 'fr', 'es']);
    console.log('IsLoadFromApp ' + csharpService.IsLoadFromApp);
    console.log('AppVersion ' + csharpService.GetVersionValue());
    // const availableLanguage = this.authentication.getUserLanguage();
    // availableLanguage ? this.translate.use(availableLanguage) : translate.setDefaultLang('en');
    const that = this;
    const HTTP = new XMLHttpRequest();
    this.cs.CurrentFlagValue.subscribe(show => this.show = show);
    this.cs.CurrentFlagMessage.subscribe(message => this.message = message);
    this.cs.getPlatform();
    this.isIframe = window !== window.parent && !window.opener;
    window['appComponentRef'] = {
      zone: this._ngZone,
      showToast: (msg) => this.showToast(msg),
      SetInitialValue: (IsURLReachable) => this.SetInitialValue(IsURLReachable),
      updateSyncPercent: (percent,tableName) => this.updateSyncPercent(percent,tableName),
      component: this,
    };
    this.router.events.subscribe(
      (event: any) => {
        if( event instanceof NavigationStart ){
          if (event.url === '/id_token') {
            const hash = window.location.hash;
            const splitHash = hash.split('#id_token=');
            if ( splitHash && splitHash.length > 0 ) {
              const HashToken = splitHash[1];
              const hashQueryParams = { queryParams: {azureToken: HashToken}};
              this.router.navigate(['/login'], hashQueryParams)
            }
          }
        }
        if (event instanceof NavigationEnd) {
          const url = this.router.url;
          const wasOnLogin = this.routerUrlSnapshotForIdleSync.includes('/login');
          this.routerUrlSnapshotForIdleSync = url;
          if (wasOnLogin && !url.includes('/login')) {
            this.cs.syncIdleTimeoutFromStoredSession();
            if (localStorage.getItem(userSessionName)) {
              this.eatecTokenRefreshService.start();
            }
          }
        }
      }
    );

   /**
    * @method Check onlone status for BASE DOMAIN
    * @description In client side check randomly online status JAVASCRIPT HTTP  new XMLHttpRequest();
    *  create the Ajax method watch randomly to API domain
    * @param input "NULL"
    * @param output <Josn Response>
    */
    const observableSynMasterData = interval(myGlobals.IntervalToSyncMasterdata);
    const SyncMasterdatasubs = observableSynMasterData.subscribe(x => {

      if (this.cs.isonlineStatus) {
        if (localStorage.getItem(myGlobals.userSessionName) !== null) {
          if (localStorage.getItem(myGlobals.instanceName) !== null) {
            const autoSync = (localStorage.getItem('autoSync') === 'true' ? true : false);
            if (autoSync === true) {
              this.callCSharpSync('Sync Masterdata');
            }
          }
        }
      }
    });


    let apiUrl = window.localStorage.getItem('apiUrl');
    if (apiUrl) {
      apiUrl =  window.localStorage.getItem('apiUrl') + apiURLs.HealthCheckAPI.ConnectionStatus;
      this.checkApiReachable(apiUrl, 1, 0).then(i => {
        that.cs.isonlineStatus = true;
        that.cs.onlineStatusChange.next(true);
        // that.configuraionService.onlineStatusChange.next(true);
      }).catch(err => {
        console.log('error');
        this.offlineText = this.translate.instant('common.offline');
        this.showToast(this.offlineText);
        that.cs.onlineStatusChange.next(false);
        // that.configuraionService.onlineStatusChange.next(false);
        that.cs.isonlineStatus = false;
      });
    }

    const observable = interval(myGlobals.randomTime);
    const subscription = observable.subscribe(x => {
      const prevstate = that.cs.isonlineStatus;
        apiUrl = window.localStorage.getItem('apiUrl');

      if (apiUrl) {
        apiUrl =  window.localStorage.getItem('apiUrl') + apiURLs.HealthCheckAPI.ConnectionStatus;
      this.checkApiReachable(apiUrl, 1, 4000).then(image => {
        console.log('success');
        if (!prevstate) {
          this.onlineText = this.translate.instant('common.online');
          this.showToast(this.onlineText);
        }

        if (!that.cs.isonlineStatus) {
          if (localStorage.getItem(myGlobals.userSessionName) !== null) {
            if (localStorage.getItem(myGlobals.instanceName) !== null) {
              //if (csharpService.IsLoadFromApp) {
                this.callCSharpSync('Sync Transaction data');
              //}
              that.cs.isonlineStatus = true;
              that.cs.onlineStatusChange.next(true);
              // that.configuraionService.onlineStatusChange.next(true);
            }
          } else {
            that.cs.isonlineStatus = false;
            that.cs.onlineStatusChange.next(false);
            // that.configuraionService.onlineStatusChange.next(false);
            if (!that.cs.IsLoginPage) {
              if (this.showOnlineAlert) {
                this.showPopUp(this.translate.instant('offline.Info'), this.translate.instant('login.backonline'), this.translate.instant('common.cancel'), this.translate.instant('common.ok'));
              }
            } else {
              that.cs.isonlineStatus = true;
              that.cs.onlineStatusChange.next(true);
              // that.configuraionService.onlineStatusChange.next(true);
            }
            // router.navigate
          }
        }

      }).catch(err => {
        console.log('error');
        if (prevstate) {
          this.offlineText = this.translate.instant('common.offline');
          this.showToast(this.offlineText);
        }
        that.cs.isonlineStatus = false;
        that.cs.onlineStatusChange.next(false);
        // that.configuraionService.onlineStatusChange.next(false);
      });
    }
    });

    /**
     * @version 13.2 UI
     * Idle Time Out
     */
    const InactiveTime = JSON.parse(appApiResources.Default_SessionInactivityTime);
    const defaultidleTime = InactiveTime * 60
    let idleStart = false;
    //idle.setIdle(JSON.parse(localStorage.getItem('idleTimeout'))); // how long can they be inactive before considered idle, in seconds //Naveen - Need to change
    idle.setTimeout(60); // how long can they be idle before considered timed out, in seconds //Naveen - Need to change
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active
    // set keepalive parameters, omit if not using keepalive
    keepalive.interval(15); // will ping at this interval while not idle, in seconds
    keepalive.onPing.subscribe(() => this.lastPing = moment().toDate()); // do something when it pings
    this.idleTimeoutSubscribtion = this.cs.InactivityTimeout.subscribe(x => {
      // if (this.authService.isAuthenticated()) {
        const getIdleTime = x;
        const seconds = Number(getIdleTime);
        if (Number.isFinite(seconds) && seconds > 0 && !this.router.url.includes('/login')) {
          idle.setIdle(seconds);
          this.idle.watch();
          this.timedOut = false;
        } else {
          this.idle.stop();
          this.timedOut = true;
        }
      // }
    });

    idle.onIdleEnd.subscribe(() => {
      this.idleState = this.translate.instant('login.Nolongeridle');
      this.cs.popupDialogText = this.idleState;
      this.resetIdleWatch();
    });

    idle.onTimeout.subscribe(() => {
      this.idle.stop();
      this.timedOut = true;      
      this.dialogRef.close('close');
      console.log("time out", this.idleState);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = this.translate.instant('login.Goneidle');
      idleStart = true;
      if(this.cs.reachedSavePage){
        window['ReceivingItemListLibComponentRef'].PostReceivingData();
        idleStart = false;
      }
      this.cs.saveSessionCall.next(true);
      this.idle.clearInterrupts();
      this.cs.popupDialogText = this.idleState;
      if(!this.router.url.includes('/login')){
        this.DisplayIdleSessionPopUp(
          this.translate.instant('login.Sessiontimeout'), '',
          this.translate.instant('login.Stayin'),
          this.translate.instant('login.Signout'));
      }
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      const myStr =
      this.translate.instant('login.SessionAbouttoexpire') + ' '  + countdown + ' ' + this.translate.instant('login.Seconds') + ' .Please save your data';            
      this.idleState = myStr;      
      this.cs.popupDialogText = this.idleState;
      console.log("warning", this.idleState);
    });
  }

  resetIdleWatch() {
    this.idle.watch();
    this.timedOut = false;
  }
  reset() {
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }
  later(){
    this.cs.passcodePopupShow.next(false);
  }
  create(){
    this.router.navigate(['/passcode']);
    this.cs.passcodePopupShow.next(false);
  }
  DisplayIdleSessionPopUp(headerText: any, contentText: any, cancelText: any, confirmText: any) {
    this.dialog.closeAll();
    this.cs.enableIdleTimeOut = true;
    this.showOnlineAlert = false;
    const dialogArray = {
      headerText: headerText,
      contentText: contentText,
      cancelText: cancelText,
      confirmText: confirmText,
      confirmHelpText: 'SIGNOUT',
      cancelHelpText: 'STAYIN',
      idleTimeoutBool: true
    };
    this.cs.mobilePopUpProperty.data = dialogArray;
    this.cs.mobilePopUpProperty.panelClass = 'idle-time-out'
    this.dialogRef = this.dialog.open(IdlePopupComponent,
      this.cs.mobilePopUpProperty
    );

    this.dialogRef.afterClosed().subscribe((result) => {
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.showOnlineAlert = true;
      if (result === 'SIGNOUT') {
        this.removeSessionIdle();
        this.idle.stop();
        this.timedOut = true;        
        this.cs.InactivityTimeout.next(0);
        this.authentication.logout();
        this.authentication.updateMobileLicenseLogout();
        // this.router.navigate(['/login']);
      }
      else if(result === 'close'){
        this.removeSessionIdle();
        this.idle.stop();
        this.timedOut = true;
        this.cs.ReceivingMenu = 0;        
        this.showPopUp('Info', 'Session Expired!!!' , '', 'OK');
        this.cs.saveSessionCall.next(false);
      }
       else if (result === 'STAYIN') {
        this.cs.enableIdleTimeOut = false;
        this.cs.saveSessionCall.next(false);
        this.resetIdleWatch();
      }
    });
  }

  removeSessionIdle() {
    sessionStorage.removeItem('activeMenuId');
    sessionStorage.removeItem('selectedMenu');
    sessionStorage.removeItem('breadCrumbRoute');
    sessionStorage.removeItem('strogeParentRoute');
    sessionStorage.removeItem('shouldReuse');
    sessionStorage.removeItem('strogeLocateRoute');
  }



  showPopUp(headerText, contentText, cancelText, confirmText) {
    this.showOnlineAlert = false;
    const dialogArray = {
      headerText: headerText, contentText: contentText, cancelText: cancelText,
      confirmText: confirmText, confirmHelpText: 'OK',
    cancelHelpText: 'CANCEL' };
    this.cs.mobilePopUpProperty.data = dialogArray;
    this.dialogRef = this.dialog.open(PopupComponent,
      this.cs.mobilePopUpProperty
    );

    this.dialogRef.afterClosed().subscribe((result) => {
      this.showOnlineAlert = true;
      if (result === 'OK') {
        this.cs.isonlineStatus = true;
        this.cs.onlineStatusChange.next(true);
        this.cs.InactivityTimeout.next(0);        
        this.cs.passcodePopupShow.next(false);
        this.cs.tempPasscodePopupShow.next(false);
        this.authentication.logout();
        this.authentication.updateMobileLicenseLogout();
      } else {
        this.showOnlineAlert = false;
      }
    });
  }

SetInitialValue(object) {
  this.csharpService.IsLoadFromApp = true;
  if (object) {
    this.csharpService.AppVersion = object.MobileAppVersion;
    this.cs.isonlineStatus = object.IsOnline;
    this.cs.onlineStatusChange.next(object.IsOnline);
  }
}

  showToast(msg) {
    this.toastShow = true;
    this.toastMessage = msg;
  }
  callCSharpSync(syncType) {
    const instanceName = localStorage.getItem(myGlobals.instanceName);
    const currentUser = JSON.parse(localStorage.getItem(myGlobals.userSessionName));
    if (currentUser != null) {

      const syncObj = {
        access_Token: currentUser.access_token, UserId: sessionStorage.getItem(myGlobals.loggedInUserId),
        siteId: sessionStorage.getItem(myGlobals.loggedInSiteId), InstanceName: instanceName, SyncType: 'auto',
        TransactionType: 0, Transcationids: '',
        SyncDataType: syncType, Modulename: myGlobals.cSharpModuleName.SyncMasterdata, Action: myGlobals.cSharpActionName.SyncMasterdata
      };
      this.csharpService.RequestGETCSharp(myGlobals.cSharpURLs.Synclocaldata, syncObj, false);
    }
  }
  checkApiReachable(target, times, delay) {
   return new Promise((res, rej) => {                       // return a promise

    (function rec(i) {                                    // recursive IIFE
      fetch(target, { mode: 'no-cors' }).then((r) => {    // fetch the resourse
        res(r);                                           // resolve promise if success
      }).catch(err => {
        if (times === 0) {                                  // if number of tries reached
          return rej(err);
        }                                // don't try again

        setTimeout(() => rec(--times), delay);             // otherwise, wait and try
      });                                                 // again until no more tries
    })(times);

  });
}

toastAutoDismiss(e) {
  this.toastShow = false;
  this.toastMessage = '';
}
ngOnInit(): void {
  this.routerUrlSnapshotForIdleSync = this.router.url;
  this.cs.syncIdleTimeoutFromStoredSession();
  if (localStorage.getItem(userSessionName) && !this.router.url.includes('/login')) {
    this.eatecTokenRefreshService.start();
  }
  // right when the component initializes, start reset state and start watching
  this.passcodePopupShow = this.cs.passcodePopupShow.subscribe((value) => {
    this.cs.canshowpasscodepopup = value;
 });
 this.tempPasscodePopupShow = this.cs.tempPasscodePopupShow.subscribe((value) => {
  this.cs.tempCanshowpasscodepopup = value;
});
this.createMesasgeSubscription = this.cs.isCreateMessageSubscribe.subscribe((value) => {
  this.cs.isCreateMessage = value;
});
this.PasscodeExpiredsubscribe = this.cs.isPasscodeExpiredsubscribe.subscribe((value) => {
  this.cs.isPasscodeExpired = value;
});
  this.reset();
}

ngOnDestroy(): void {
  if (this.passcodePopupShow) {
    this.passcodePopupShow.unsubscribe();
  }
  if (this.tempPasscodePopupShow) {
    this.tempPasscodePopupShow.unsubscribe();
  }
  if (this.createMesasgeSubscription) {
    this.createMesasgeSubscription.unsubscribe();
  }
  if (this.PasscodeExpiredsubscribe) {
    this.PasscodeExpiredsubscribe.unsubscribe();
  }
}

updateSyncPercent(percent,tableName){
  this.cs.syncedPercent = percent;
  this.cs.tableName = tableName;
}


}
